import { el, setChildren, mount, unmount } from 'redom';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import './index.css';

const globalState = {
  delay: 200,
  tooltipsContainer: null,
  active: false,
  futureCallReferences: {
    display: null,
    hide: null
  }
};

class Tooltip {

  constructor(configuration) {

    this.content = this.buildTooltipContent(configuration.content);
    this.target = configuration.target;
    this.placement = configuration.placement || 'bottom';
    this.offset = configuration.offset || 0;
    this.placeOnCenter = configuration.placeOnCenter !== false;
    this.displayed = false;

    this.handleMouseEnterEvent = this.handleMouseEnterEvent.bind(this);
    this.handleMouseLeaveEvent = this.handleMouseLeaveEvent.bind(this);

    this.target.addEventListener('mouseenter', this.handleMouseEnterEvent);
    this.target.addEventListener('mouseleave', this.handleMouseLeaveEvent);
    this.target.classList.add('tooltip-target');

    this.el = el('.tooltip-main', [this.content]);

  }

  destroy() {
    this.hideTooltip();
    this.target.removeEventListener('mouseenter', this.handleMouseEnterEvent);
    this.target.removeEventListener('mouseleave', this.handleMouseLeaveEvent);
    this.target.classList.remove('tooltip-target');
  }

  buildTooltipContent(content) {

    if (typeof content === 'string') {
      return el('label', content);
    }

    return content;

  }

  getTooltipsContainer() {

    if (globalState.tooltipsContainer === null) {
      globalState.tooltipsContainer = document.getElementById('tooltips-container') || el('#tooltips-container');
      mount(document.body, globalState.tooltipsContainer);
    }

    return globalState.tooltipsContainer;

  }

  displayTooltip() {

    globalState.active = true;
    this.displayed = true;

    setChildren(this.getTooltipsContainer(), [this.el]);

    const element = this.el;
    const anchorElement = this.target;
    const viewportElement = document.body;
    const verticalOffset = 5;
    const horizontalOffset = 5;
    const startSide = this.placement;
    const placeOnCenter = this.placeOnCenter;
    const positionableSides = [this.placement];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

    element.style.height = 'auto';

  }

  hideTooltip() {

    globalState.active = false;
    this.displayed = false;

    unmount(this.getTooltipsContainer(), this.el);

  }

  handleMouseEnterEvent() {

    if (globalState.active === true) {
      clearInterval(globalState.futureCallReferences.hide);
      this.displayTooltip();
    } else {
      globalState.futureCallReferences.display = setTimeout(this.displayTooltip.bind(this), globalState.delay);
    }

  }

  handleMouseLeaveEvent() {

    globalState.futureCallReferences.hide = setTimeout(this.hideTooltip.bind(this), globalState.delay);

  }

  update(configuration) {

    this.content = this.buildTooltipContent(configuration.content);

    setChildren(this.el, [this.content]);

    if (this.displayed === true) {
      this.displayTooltip();
    }

  }

}

export default Tooltip;